import { defineStore } from "pinia";
import axios from "../../axios/requestAxios";
import storeExtensions from "../../utils/store-extensions";
import notify from "devextreme/ui/notify";
import { i18n } from "../../i18n";

export const useTaxiDepotStore = defineStore("taxi-depot", {
	state: () => {
		return {
			taxiDepot: null,
			taxiDepots: null,
			indexTaxiDepots: null,
			loader: false,
		};
	},
	getters: {},
	actions: {
		getUserData() {
			const securityJSON = localStorage.getItem("security");
			const securityObj = JSON.parse(securityJSON);
			this.userId = securityObj?.user?.oid;
		},
		async getAll() {
			return await axios
				.get("api/TaxiDepot")
				.then((response) => {
					this.taxiDepots = response.data;
				})
				.catch((error) => {
					notify(error?.response?.data.detail, "error", 2000);
					notify(error, "error", 2000);
				});
		},
		async getIndex({ loadOptions }) {
			let params = storeExtensions.getParams(loadOptions);
			return await axios
				.get(`api/TaxiDepot/Index/${params}`)
				.then((response) => {
					this.indexTaxiDepots = response.data;
				})
				.catch((error) => {
					notify(error?.response?.data.detail, "error", 2000);
					notify(error, "error", 2000);
				});
		},
		async get(brandId) {
			return await axios
				.get("api/TaxiDepot/" + brandId)
				.then((response) => {
					this.taxiDepot = response.data;
				})
				.catch((error) => {
					notify(error, "error", 2000);
				});
		},

		async update(taxiData) {
			const { t } = i18n.global;
			this.loader = true;
			return await axios
				.put("api/TaxiDepot/" + taxiData.oid, taxiData)
				.then(async () => {
					await this.get(taxiData.oid);
					notify(t("Notify.SuccessUpdateMessage"), "success", 2000);
				})
				.catch((error) => {
					notify(error?.response?.data.detail, "error", 2000);
					notify(error, "error", 2000);
				})
				.finally(() => {
					this.loader = false;
				});
		},

		async create(taxiData) {
			this.getUserData();
			taxiData.createsUserId = this.userId;
			const { t } = i18n.global;
			return await axios
				.post("api/TaxiDepot", taxiData)
				.then(async () => {
					notify(t("Notify.SuccessCreateMessage"), "success", 2000);
				})
				.catch((error) => {
					notify(error?.response?.data.detail, "error", 2000);
					notify(error, "error", 2000);
				});
		},

		async delete(taxiOid) {
			const { t } = i18n.global;
			return await axios
				.post("api/TaxiDepot/Delete", taxiOid)
				.then(async () => {
					notify(t("Notify.SuccessDeleteMessage"), "success", 2000);
				})
				.catch((error) => {
					notify(error?.response?.data.detail, "error", 2000);
					notify(error, "error", 2000);
				});
		},
	},
});
